import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Registro from './pages/Registro';
import Dashboard from './pages/Dashboard';
import Empleados from './pages/Empleados';
import EmpleadoDetalle from './pages/EmpleadoDetalle';
import Fichajes from './pages/Fichajes';
import FichajeDetalle from './pages/FichajeDetalle';
import Proyectos from './pages/Proyectos';
import ProyectoDetalle from './pages/ProyectoDetalle';
import ProyectoNuevo from './pages/ProyectoNuevo';
import ProyectoEditar from './pages/ProyectoEditar';
import Clientes from './pages/Clientes';
import ClienteDetalle from './pages/ClienteDetalle';
import ClienteForm from './pages/ClienteForm';
import Horas from './pages/Horas';
import HoraDetalle from './pages/HoraDetalle';
import ImputacionDiaria from './pages/ImputacionDiaria';
import Ausencias from './pages/Ausencias';
import AusenciaDetalle from './pages/AusenciaDetalle';
import Configuracion from './pages/Configuracion';
import TrialExpirado from './pages/TrialExpirado';
import Superadmin from './pages/Superadmin';

function RutaProtegida({ children }) {
  const { usuario, trialExpirado } = useAuth();
  if (!usuario) return <Navigate to="/login" />;
  if (trialExpirado) return <TrialExpirado />;
  if (usuario.rol === 'superadmin') return <Navigate to="/superadmin" />;
  return <Layout>{children}</Layout>;
}

function RutaSuperadmin({ children }) {
  const { usuario } = useAuth();
  if (!usuario) return <Navigate to="/login" />;
  if (usuario.rol !== 'superadmin') return <Navigate to="/dashboard" />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/registro" element={<Registro />} />
          <Route path="/superadmin" element={<RutaSuperadmin><Superadmin /></RutaSuperadmin>} />
          <Route path="/dashboard" element={<RutaProtegida><Dashboard /></RutaProtegida>} />
          <Route path="/empleados" element={<RutaProtegida><Empleados /></RutaProtegida>} />
          <Route path="/empleados/:id" element={<RutaProtegida><EmpleadoDetalle /></RutaProtegida>} />
          <Route path="/fichajes" element={<RutaProtegida><Fichajes /></RutaProtegida>} />
          <Route path="/fichajes/:id" element={<RutaProtegida><FichajeDetalle /></RutaProtegida>} />
          <Route path="/proyectos" element={<RutaProtegida><Proyectos /></RutaProtegida>} />
          <Route path="/proyectos/nuevo" element={<RutaProtegida><ProyectoNuevo /></RutaProtegida>} />
          <Route path="/proyectos/:id/editar" element={<RutaProtegida><ProyectoEditar /></RutaProtegida>} />
          <Route path="/proyectos/:id" element={<RutaProtegida><ProyectoDetalle /></RutaProtegida>} />
          <Route path="/clientes" element={<RutaProtegida><Clientes /></RutaProtegida>} />
          <Route path="/clientes/nuevo" element={<RutaProtegida><ClienteForm /></RutaProtegida>} />
          <Route path="/clientes/:id" element={<RutaProtegida><ClienteDetalle /></RutaProtegida>} />
          <Route path="/clientes/:id/editar" element={<RutaProtegida><ClienteForm /></RutaProtegida>} />
          <Route path="/horas" element={<RutaProtegida><Horas /></RutaProtegida>} />
          <Route path="/horas/:id" element={<RutaProtegida><HoraDetalle /></RutaProtegida>} />
          <Route path="/imputacion" element={<RutaProtegida><ImputacionDiaria /></RutaProtegida>} />
          <Route path="/ausencias" element={<RutaProtegida><Ausencias /></RutaProtegida>} />
          <Route path="/ausencias/:id" element={<RutaProtegida><AusenciaDetalle /></RutaProtegida>} />
          <Route path="/configuracion" element={<RutaProtegida><Configuracion /></RutaProtegida>} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
